var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPineappleNofill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512",
      opacity: 0.2
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m20.864 55.231 9.544 2.457c-2.565 2.2-5.102 3.82-7.687 4.65z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.864 55.231 1.856 7.107c-2.97.985-5.993.918-9.159-.52l-2.322-9.058z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.864 55.231-9.625-2.47-2.477-9.618 9.591 2.504z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.239 52.761 2.322 9.058c-2.119-.958-4.306-2.524-6.581-4.799s-3.84-4.461-4.799-6.581z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.239 52.761-9.058-2.322c-1.438-3.165-1.505-6.189-.52-9.159l6.952 1.822.148.04z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.312 33.592 2.45 9.55-.148-.04-6.952-1.822c.83-2.585 2.45-5.123 4.65-7.688z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.353 45.647-9.591-2.504-2.45-9.551 9.699 2.504z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.696 26.641 2.315 9.456-9.699-2.504c.823-.958 1.721-1.924 2.693-2.895 1.479-1.479 3.051-2.849 4.691-4.057z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.99 28.915-9.28-2.288c2.43-1.809 5.008-3.253 7.613-4.171z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.99 28.915 2.477 9.618-9.456-2.437-2.315-9.456c0-.014.007-.02.013-.014z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.467 38.533 2.437 9.456-9.551-2.342-2.342-9.551z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.408 57.688-9.544-2.457-2.511-9.584 9.551 2.342z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.303 54.995c-.972.972-1.937 1.87-2.895 2.693l-2.504-9.699 9.456 2.315c-1.209 1.64-2.579 3.212-4.057 4.691z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.373 50.29-2.288-9.28 6.459 1.667c-.918 2.605-2.362 5.184-4.171 7.613z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.373 50.29c.007.007 0 .014-.014.014l-9.456-2.315-2.437-9.456 9.618 2.477z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.544 42.677-6.459-1.667-2.389-9.706 9.685 2.558c.567 2.876.202 5.859-.837 8.815z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.085 41.01-9.618-2.477-2.477-9.618 9.706 2.389z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.696 31.304-9.706-2.389-1.667-6.459c2.956-1.039 5.939-1.404 8.815-.837z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.381 33.862-9.685-2.558-2.558-9.685c1.363.256 2.706.722 3.996 1.431 1.35.715 2.652 1.681 3.894 2.922s2.207 2.544 2.922 3.894c.709 1.29 1.174 2.633 1.431 3.996z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.926 7.074s1.019 4.07-1.363 7.802c-1.789-.574-3.834-.81-6.061-.378.432-2.227.196-4.272-.378-6.061 3.732-2.382 7.802-1.363 7.802-1.363z",
    fill: "#ffc852",
    "data-original": "#ffc852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.123 8.438c.574 1.789.81 3.834.378 6.061 0 0-4.725-2.025-9.449 2.7.317-1.897.115-3.57-.385-5.028 5.09-5.319 4.435-11.171 4.435-11.171s3.577 2.875 5.021 7.438z",
    fill: "#ffc852",
    "data-original": "#ffc852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.562 14.877c4.563 1.444 7.438 5.021 7.438 5.021s-5.852-.655-11.17 4.434c-1.458-.499-3.132-.702-5.028-.385 4.725-4.725 2.7-9.449 2.7-9.449 2.227-.431 4.272-.195 6.06.379z",
    fill: "#ffc852",
    "data-original": "#ffc852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.83 24.332c4.752 1.62 7.121 6.365 7.121 6.365s-9.807-2.45-16.57 3.165c-.256-1.363-.722-2.706-1.431-3.996-.715-1.35-1.681-2.652-2.922-3.894s-2.544-2.207-3.894-2.922c-1.289-.709-2.632-1.174-3.996-1.431 5.615-6.763 3.165-16.57 3.165-16.57s4.745 2.369 6.365 7.121c.499 1.458.702 3.132.385 5.028 4.725-4.725 9.449-2.7 9.449-2.7s2.025 4.725-2.7 9.449c1.896-.317 3.57-.114 5.028.385z",
    fill: "#ffc852",
    "data-original": "#ffc852"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffc852"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.779 19.271c-.115-.143-2.655-3.25-6.781-4.932 1.805-3.709.94-7.341.898-7.508-.09-.358-.369-.638-.728-.728-.167-.042-3.8-.908-7.508.898-1.683-4.127-4.789-6.666-4.932-6.781-.315-.253-.75-.291-1.105-.097-.354.193-.558.583-.516.984.022.204.43 4.679-3.155 9.203-2.076-4.048-6.016-6.063-6.202-6.156-.35-.176-.768-.13-1.072.114s-.439.643-.345 1.021c.022.091 2.131 8.979-2.638 15.246-2.733-.417-5.656-.096-8.705.975-2.599.916-5.221 2.346-7.794 4.25-1.26 1.021-3.376 2.705-4.898 4.227-.986.987-1.909 1.979-2.744 2.952-2.435 2.838-4.02 5.466-4.841 8.023-1.117 3.367-.934 6.601.558 9.886 1.025 2.268 2.708 4.581 5.002 6.875s4.608 3.978 6.874 5.002c1.878.853 3.739 1.278 5.616 1.278 1.407 0 2.824-.239 4.263-.717 2.567-.824 5.194-2.409 8.034-4.844.971-.834 1.967-1.755 2.951-2.744 2.147-2.158 4.188-4.833 4.227-4.898 1.904-2.573 3.334-5.195 4.25-7.795 1.073-3.05 1.393-5.975.976-8.704 6.266-4.768 15.154-2.66 15.246-2.638.377.095.777-.041 1.021-.345.244-.305.289-.723.114-1.072-.093-.186-2.108-4.128-6.156-6.203 4.525-3.586 8.999-3.179 9.2-3.156.407.05.792-.157.988-.512.194-.35.156-.788-.098-1.104zm-7.719-11.331c.138 1.097.218 3.468-.998 5.778-1.46-.373-2.932-.506-4.404-.376.13-1.473-.002-2.946-.376-4.405 2.311-1.215 4.683-1.134 5.778-.997zm-11.032-4.608c1.063 1.216 2.408 3.089 3.143 5.412.476 1.482.629 2.985.488 4.483-1.563-.306-4.412-.411-7.465 1.709-.036-.854-.196-1.688-.427-2.506 3.019-3.359 3.988-6.846 4.261-9.098zm-11.363 20.601c1.286.682 2.515 1.606 3.656 2.747s2.065 2.37 2.753 3.668c.37.673.668 1.38.907 2.11l-7.467-1.972-1.972-7.467c.73.24 1.441.54 2.123.914zm-4.649 32.363-7.335-1.883-1.935-7.395 7.341 1.798zm-5.607 4.724-1.149-4.392 5.97 1.533c-1.68 1.284-3.274 2.231-4.821 2.859zm-20.49-11.424c-.978-2.362-1.169-4.696-.563-7.101l5.586 1.462 1.905 7.418zm14.063-5.341-7.396-1.935-1.884-7.336 7.481 1.929zm-9.61-2.514-4.393-1.15c.626-1.544 1.574-3.139 2.86-4.821zm2.783 2.795 7.379 1.931 1.93 7.378-7.407-1.902zm9.025.284-1.799-7.341 7.266 1.873 1.873 7.266zm-4.124-16.831 7.113 1.752 1.908 7.399-7.236-1.866zm5.582-4.182.963 3.734-5.503-1.356c1.513-.98 3.031-1.763 4.54-2.378zm3.736 6.477 7.495 1.846 1.846 7.495-7.426-1.915zm2.486 9.64 7.399 1.908 1.752 7.113-7.286-1.785zm9.598 2.475 3.734.963c-.615 1.51-1.398 3.028-2.378 4.54zm-.543-2.206-1.846-7.492 7.426 1.962c.315 2.133.111 4.417-.615 6.811zm-6.578-17.688 1.961 7.426-7.492-1.846-1.28-4.966c2.392-.725 4.674-.929 6.811-.614zm-19.625 8.899c1.098-1.098 2.23-2.114 3.378-3.035l1.553 6.339-6.49-1.673c.499-.543 1.016-1.087 1.559-1.631zm-5.555 20.575 6.257 1.607 1.607 6.257c-1.428-.899-2.878-2.075-4.334-3.53-1.454-1.456-2.631-2.906-3.53-4.334zm10.248 9.103-1.779-6.928 7.418 1.905 1.462 5.587c-2.4.605-4.736.415-7.101-.564zm18.191-6.795c-.544.544-1.089 1.061-1.63 1.559l-1.673-6.49 6.339 1.553c-.922 1.149-1.938 2.281-3.036 3.378zm24.264-24.957c-3.173-.372-9.001-.444-13.875 2.839-.209-.694-.468-1.37-.778-2.021 1.814-1.368 3.283-1.746 3.323-1.756.536-.125.871-.66.749-1.197-.123-.538-.658-.874-1.198-.752-.08.018-1.757.416-3.845 1.93-.519-.822-1.131-1.614-1.818-2.375l3.367-3.367c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.367 3.367c-.763-.688-1.556-1.301-2.375-1.818 1.515-2.088 1.912-3.765 1.93-3.845.122-.537-.212-1.069-.749-1.194-.532-.126-1.073.208-1.2.744-.004.016-.378 1.494-1.757 3.323-.654-.311-1.329-.569-2.021-.778 3.283-4.874 3.21-10.7 2.839-13.875 1.389 1.076 3.205 2.871 4.051 5.354.492 1.437.608 2.964.344 4.539-.072.429.142.855.528 1.054.387.199.858.125 1.165-.182 3.453-3.453 6.817-2.933 7.951-2.618.308 1.129.826 4.512-2.616 7.954-.308.308-.381.778-.182 1.165.199.386.625.599 1.054.528 1.576-.264 3.104-.148 4.541.345 2.482.845 4.277 2.661 5.353 4.05zm-5.289-6.097c-.819-.231-1.652-.391-2.506-.427 2.12-3.053 2.014-5.902 1.708-7.465 1.498-.14 3.002.013 4.487.489 2.32.734 4.192 2.079 5.408 3.142-2.252.273-5.739 1.242-9.097 4.261z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.777,
    cy: 19.223,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.673,
    cy: 28.327,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.818,
    cy: 25.562,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.037,
    cy: 34.963,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.226 31.726c-.391-.391-1.026-.391-1.417 0s-.391 1.026 0 1.417 1.026.391 1.417 0c.392-.391.392-1.025 0-1.417z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.363,
    cy: 39.589,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.209,
    cy: 46.743,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.438,
    cy: 37.182,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.24 43.808c-.373-.373-.977-.373-1.35 0s-.373.977 0 1.35.977.373 1.35 0 .373-.978 0-1.35z",
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.411,
    cy: 51.637,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.256,
    cy: 58.791,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.957,
    cy: 42.043,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.796,
    cy: 49.204,
    r: 1.002,
    fill: "#ffc852",
    "data-original": "#ffc852",
    className: ""
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineappleNofill);
export default __webpack_public_path__ + "static/media/pineapple-nofill.6af36ad11012e58a076bf39db97ccae9.svg";
export { ForwardRef as ReactComponent };